import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "1", title: "We identify students", text: "Teachers flag concerns; we help you spot the children who would benefit most." },
  { n: "2", title: "We screen & assess", text: "Structured screenings and assessments in school — up to 10 students per visit." },
  { n: "3", title: "We write therapy plans", text: "Every child gets an individualised plan with clear, measurable goals." },
  { n: "4", title: "Our therapist delivers sessions", text: "Group or one-to-one therapy, timetabled around the school day." },
  { n: "5", title: "You receive progress reports", text: "Plain-language monthly reports for parents and management." },
  { n: "6", title: "We review together", text: "Every 4 weeks we sit down with you to review progress and adjust plans." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="border-y border-pine-900/10 bg-sand py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">The journey</p>
        <h2 className="max-w-xl font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
          How it works — six steps, zero disruption.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={(i % 3) * 0.08}>
            <div
              data-testid={`how-step-${s.n}`}
              className="group relative h-full rounded-3xl border border-pine-900/10 bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-honey hover:shadow-xl"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-pine-900 font-serif text-base font-semibold text-honey">
                {s.n}
              </span>
              <h3 className="mt-6 font-serif text-lg font-semibold text-pine-950 sm:text-xl">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-stone-600">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
